export default __webpack_public_path__ + "static/media/skippedmeal_1.ab1a0940.jpg";